import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { Portal } from '@xingternal/portal';
import { BottomSheetPrimitive } from './bottom-sheet.primitive';
import * as Styled from './bottom-sheet.styles';
const { bottomSheetDuration, bottomSheetTransitionName, dimmerDuration, dimmerTransitionName, } = Styled;
export const BottomSheet = ({ children, className, dimmerTitle, keepBottomSheetInDom, onOutsideClick, show = false, showCloseButton = true, shouldDisableBodyScroll = true, ...props }) => {
    const disableScrolling = () => {
        document.body.style.overflow = 'hidden';
    };
    const enableScrolling = () => {
        document.body.style.overflow = 'visible';
    };
    const closeModal = (event) => {
        event.stopPropagation();
        enableScrolling();
        onOutsideClick && onOutsideClick(event);
    };
    React.useEffect(() => {
        if (!shouldDisableBodyScroll) {
            return;
        }
        if (show) {
            disableScrolling();
        }
        return () => {
            if (!shouldDisableBodyScroll) {
                return;
            }
            enableScrolling();
        };
    }, [show, shouldDisableBodyScroll]);
    const BottomSheetTransition = (React.createElement(CSSTransition, { appear: show, classNames: bottomSheetTransitionName, in: show, key: "bottomSheet", mountOnEnter: !keepBottomSheetInDom, timeout: parseInt(bottomSheetDuration), unmountOnExit: !keepBottomSheetInDom },
        React.createElement(BottomSheetPrimitive, { className: className, "data-show": show, closeModal: closeModal, showCloseButton: showCloseButton, ...props }, children)));
    const DimmerTransition = (React.createElement(CSSTransition, { appear: show, classNames: dimmerTransitionName, in: show, key: "dimmer", mountOnEnter: true, onEnter: disableScrolling, onExited: enableScrolling, timeout: parseInt(dimmerDuration), unmountOnExit: true },
        React.createElement(Styled.Dimmer, { "$isNotClickable": !onOutsideClick, "data-qa": "bottom-sheet-dimmer", "data-testid": "bottom-sheet-dimmer", onClick: closeModal, title: dimmerTitle })));
    return (React.createElement(React.Fragment, null,
        React.createElement(Portal, null, BottomSheetTransition),
        DimmerTransition));
};
BottomSheet.displayName = 'BottomSheet';
//# sourceMappingURL=bottom-sheet.js.map